/** The board roles P0 grants, weakest first. Each holds every permission of
 * the ones before it, so the order is the rank: a grant only raises a
 * member's role, and a revoke only lowers it. Never `owner` or `coowner`:
 * those can share the board, which P0 keeps to the connector user. */
export const MIRO_AI_BOARD_ROLES = ["viewer", "commenter", "editor"] as const;

export type MiroAiBoardRole = (typeof MIRO_AI_BOARD_ROLES)[number];

/** How `role` ranks against the other roles P0 grants: higher is stronger. */
export const miroAiBoardRoleRank = (role: MiroAiBoardRole) =>
  MIRO_AI_BOARD_ROLES.indexOf(role);

/** What a grant records as the role P0 set: one it grants, or `unchanged`
 * when the member already held it or one above it, so P0 wrote nothing. */
export const MIRO_AI_ROLES_SET = [...MIRO_AI_BOARD_ROLES, "unchanged"] as const;

export type MiroAiRoleSet = (typeof MIRO_AI_ROLES_SET)[number];

/** Every role a member can hold on a board before P0 grants, weakest first:
 * `none` for someone who isn't a direct member, then each role Miro reports,
 * including the two P0 never grants. The connector ranks them the same way. */
export const MIRO_AI_PRIOR_ROLES = [
  "none",
  ...MIRO_AI_BOARD_ROLES,
  "coowner",
  "owner",
] as const;

export type MiroAiPriorRole = (typeof MIRO_AI_PRIOR_ROLES)[number];

/** How a prior role ranks: higher is stronger, and `none` is the lowest. */
export const miroAiPriorRoleRank = (role: MiroAiPriorRole) =>
  MIRO_AI_PRIOR_ROLES.indexOf(role);
